import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VisualizadorLogService } from '../../../shared/services/apis/srv-log/visualizador-log.service';
import { ListaLogRequest } from '../../../shared/services/requests/srv-log/lista-log.request';
import { ListaLogResponse } from '../../../shared/services/responses/srv-log/lista-log.response';
import { LogStruct } from '../../../shared/services/structs/srv-log/log.struct';
import { ListaEmpresaAdminService } from '../../../shared/services/apis/usuario/lista-empresa-admin.service';
import { ListaEmpresaAdminResponse } from '../../../shared/services/responses/usuario/lista-empresa-admin.response';
import { Empresa } from '../../../shared/services/models/usuario/empresa.model';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ChipStatusComponent } from '../../../shared/components/chip-status/chip-status.component';
import { environment } from '../../../../environments/environment';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';

@Component({
  selector: 'app-visualizar-log-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    MatSlideToggleModule,
    ChipStatusComponent,
    SelectPesquisavelComponent,
  ],
  templateUrl: './visualizar-log-lista.component.html',
  styleUrl: './visualizar-log-lista.component.css',
})
export class VisualizarLogListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private visualizadorLogService: VisualizadorLogService,
    private listaEmpresaAdminService: ListaEmpresaAdminService,
    private alertService: AlertService,
    private dialog: MatDialog,
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_Logs;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaLogResponse: ListaLogResponse | undefined;
  public displayedColumns: string[] = [
    'idLog',
    'idEmpresa',
    'tipo',
    'projetoOrigem',
    'funcaoOrigem',
    'datetimeInclusao',
    'action-edit',
  ];
  public _dataSource = new MatTableDataSource<LogStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public listaEmpresa: Empresa[] = [];
  public modoPainel: boolean;
  public ultimoId: number;
  private intervaloModoPainel: ReturnType<typeof setInterval>;
  public _urlListEmpresa: string;
  public preloadedEmpresa: any = [];

  ngOnInit(): void {
    this._urlListEmpresa = environment.urlApiUsuario + "ListaEmpresaAdmin"; 
    this.model = this.formBuilder.group({
      idLog: [''],
      textoBusca: [''],
      listIdEmpresa: [null],
      tipo: [null],
    });

    this.listarEmpresa();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;

    const idLog: number =
      this.model.get('idLog')?.value.toString().trim() === '' ? null : this.model.get('idLog')?.value;
    const textoBusca: string =
      this.model.get('textoBusca')?.value.toString().trim() === ''
        ? null
        : this.model.get('textoBusca')?.value;
    const listIdEmpresa: number[] = this.model.get('listIdEmpresa')?.value;
    const tipo: string = this.model.get('tipo')?.value;

    const request: ListaLogRequest = new ListaLogRequest();
    request.idLog = idLog;
    request.textoBusca = textoBusca;
    request.listaIdEmpresa = listIdEmpresa;
    request.tipo = tipo;
    request.paginaAtual = this._paginaAtual;

    this.visualizadorLogService.listarLogs(request).subscribe({
      next: (response: ListaLogResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;
        if (!this._listaLogResponse) {
          this._listaLogResponse = response;
          this._ultimaPagina = false;
        } else if (response.listaLogStruct?.length > 0) {
          if (this.ultimoId < response.listaLogStruct[0]?.idLog) {
            if (this.modoPainel) {
              const audio = new Audio();
              audio.src = '';
              audio.load();
              audio.play();
            }
            this.ultimoId = response.listaLogStruct[0]?.idLog;
          }

          this._listaLogResponse.listaLogStruct.push(...response.listaLogStruct);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaLogResponse.listaLogStruct;
      },
      // Validar aqui, pq não vai ser um ReturnStruct, e sim um unknown
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  private listarEmpresa(): void {
    this.listaEmpresaAdminService.get().subscribe({
      next: (response: ListaEmpresaAdminResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listaEmpresa = response.list;
        this.pesquisar();
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaLogResponse = undefined;
    this.pesquisar();
  }

  changeMode(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.pesquisar();
    }
  }

  public buscarNomeEmpresa(idEmpresa: number): string | undefined {
    if (idEmpresa === -1 || !idEmpresa) {
      return 'Admin';
    }

    if (!this.listaEmpresa || this.listaEmpresa.length <= 0) {
      return '';
    }

    return this.listaEmpresa.find(l => l.idEmpresa === idEmpresa)?.nomeEmpresa;
  }

  somenteNumeros(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (!/[0-9]/.test(event.key) && event.key !== 'Enter') {
      this.alertService.show('Erro', 'Somente números são permitidos.', AlertType.warning);
      event.preventDefault();
    }
  }

  public get listIdEmpresaControl(): FormControl {
    return this.model.get('listIdEmpresa') as FormControl;
  }
}
